<template>
    <div>
    <div class="input-group">
        <input
            type="date"
            :class="'form-control ' + input.class"
            :value="value"
            @input="e => handleChange(e)"
            :placeholder="input.placeholder"
            :required="!input.optional"
            :disabled="input.disabled"
            :readonly="input.readonly"
            :name="input.name"
            :max="new Date().toISOString().split('T')[0]" onkeydown="return false"
            min="1900-01-01"
        />
    </div>
    <h5 v-if="input.age_count" class="text-muted mt-2">Usia: {{age}}</h5>
    </div>
</template>
<script>
import {getAge} from '@/data/helper.js'
export default {
    name: 'ManualDatepicker',
    components: {},
    props: {
        input: Object,
        value: String
    },
    data: function() {
        return {
            age:""
        };
    },
    beforeRouteUpdate(){
        this.value=null;
    },
    methods: {
        handleChange(e) {
            this.$emit("handleChange", e);
            if(this.input.age_count){
                this.age = getAge(e.target.value);
            }
        }
    }
}
</script>
<style>



</style>